<script setup lang="ts">
import type { SortField } from '~/models/Content/Sort'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { RadioGroupRoot } from 'reka-ui'
import { faList } from '@fortawesome/duotone-regular-svg-icons'
import Button from '~/components/ui/Button.vue'
import AuRadio from '~/components/ui/AuRadio.vue'
import AuPopover from '~/components/ui/AuPopover.vue'

const { field } = defineProps<{ field: SortField }>()

const emit = defineEmits(['setSortField'])
const { t } = useI18n()
const fields: SortField[] = ['score', 'modified', 'published']

const fieldValue = computed({
  get: () => field,
  set: field => emit('setSortField', field)
})
</script>

<template>
  <AuPopover side="bottom" :tooltip-content="t('search.sortField.sorting')">
    <template #trigger>
      <Button
        size="sm"
        shape="square"
        variant="outline"
        :aria-label="t('search.sortField.sorting')"
      >
        <font-awesome-icon :icon="faList" />
      </Button>
    </template>
    <template #content>
      <RadioGroupRoot v-model="fieldValue">
        <Button
          v-for="sortField in fields"
          :key="sortField"
          variant="ghost"
          size="sm"
          type="label"
          full-width
        >
          <AuRadio
            :id="sortField"
            :value="sortField"
            shade="dark"
          />
          {{ t(`search.sortField.${sortField}`) }}
        </Button>
      </RadioGroupRoot>
    </template>
  </AuPopover>
</template>
